import React from "react";

export const Avatar = ({ initials = "?", color = "#7228C8", size = 48, ring = false }) => {
  const bg = color;
  const isLight = bg === "#FAF9FB" || bg === "#DEDAE2";
  const fg = isLight ? "#1E1924" : "#FFFFFF";
  return (
    <div
      aria-hidden
      style={{
        width: size,
        height: size,
        borderRadius: 999,
        background: bg,
        color: fg,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: 700,
        fontSize: size * 0.4,
        letterSpacing: "-0.02em",
        boxShadow: ring ? "0 0 0 3px rgba(114,40,200,0.15)" : "none",
        flexShrink: 0,
      }}
    >
      {initials}
    </div>
  );
};
